import routes from './router'
import Router from 'vue-router'
import {formatRoutes,loadView} from './utils/index'
import { getAccessToken, getUserRole, restoreAuthSession } from './utils/auth'
const createRouter = () => new Router({
	routes,
})
let isMenus = false;
const router = createRouter();
router.beforeEach(async(to, from, next) => {
	restoreAuthSession();
	const token = getAccessToken();
	if (!token && to.path !== '/login') {
		next({ path: '/login' });
	} else if (!hasRoutePermission(to)) {
		next({ path: '/index' });
	} else {
		next();
	}
})

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err);
};
export default router

function hasRoutePermission(route) {
	const requiredRoles = route.matched.reduce((roles, item) => {
		if (item.meta && item.meta.roles && item.meta.roles.length) {
			return roles.concat(item.meta.roles);
		}
		return roles;
	}, []);
	if (!requiredRoles.length) {
		return true;
	}
	const userRoles = parseUserRoles(getUserRole());
	return requiredRoles.some((role) => userRoles.indexOf(role) > -1);
}

function parseUserRoles(roleText) {
	if (Array.isArray(roleText)) {
		return roleText;
	}
	return String(roleText || '')
		.replace(/^\[/, '')
		.replace(/\]$/, '')
		.split(',')
		.map((role) => role.trim())
		.filter(Boolean);
}



// WEBPACK FOOTER //
// ./src/permission.js